function PrivacyPage() {
  return (
    <div className="legal-page">
      <h1>隐私协议</h1>
      <p className="last-updated">最后更新日期：2026年3月30日</p>

      <p>Ji'an Jizhou District Hilo Internet Studio（"我们"、"我们的"或"本应用"）非常重视用户的隐私保护。本隐私协议旨在向您说明我们如何收集、使用、存储和保护您的个人信息。请您在使用 TradeMirror 服务前仔细阅读本协议。</p>

      <h2>一、信息收集</h2>
      
      <h3>1.1 您主动提供的信息</h3>
      <ul>
        <li><strong>账户信息</strong>：当您注册或使用 Apple 登录时，我们可能会收集您的用户标识符（User ID）、昵称等基本信息。</li>
        <li><strong>交易记录</strong>：您在应用内填写的交易计划、持仓变化、复盘记录等内容。这些数据是应用的核心功能所必需。</li>
        <li><strong>反馈信息</strong>：您通过应用内的反馈功能提交的意见和建议。</li>
      </ul>

      <h3>1.2 自动收集的信息</h3>
      <ul>
        <li><strong>设备信息</strong>：设备型号、操作系统版本、设备标识符（用于故障排查和统计分析）。</li>
        <li><strong>使用数据</strong>：应用使用频率、功能使用情况、崩溃日志等（用于改进产品体验）。</li>
        <li><strong>订阅信息</strong>：您的 VIP 订阅状态、购买记录（通过 Apple App Store 处理，我们不直接存储支付信息）。</li>
      </ul>

      <h2>二、信息使用</h2>
      <p>我们使用收集的信息用于以下目的：</p>
      <ul>
        <li>提供、维护和改进 TradeMirror 的核心功能</li>
        <li>同步您的数据到云端，确保多设备数据一致</li>
        <li>通过 AI 分析您的交易记录，生成复盘报告和行为画像</li>
        <li>处理您的订阅和付款（通过 Apple 的系统）</li>
        <li>发送应用更新、功能介绍等服务通知</li>
        <li>分析使用趋势，优化产品体验</li>
      </ul>

      <h2>三、AI 服务与数据</h2>
      <div className="highlight-box">
        <p><strong>重要说明</strong>：TradeMirror 的 AI 深度复盘功能需要向第三方 AI 服务（如 Google Gemini、豆包等）发送您的交易数据进行分析。</p>
        <ul style={{ marginBottom: 0 }}>
          <li>我们仅在您主动使用 AI 分析功能时才会发送相关数据</li>
          <li>发送的数据仅限于完成分析所必需的交易记录字段</li>
          <li>我们要求 AI 服务提供商遵守严格的数据保护协议</li>
          <li>AI 服务不会将您的数据用于模型训练或任何其他目的</li>
        </ul>
      </div>

      <h2>四、信息存储与保护</h2>
      
      <h3>4.1 数据存储</h3>
      <ul>
        <li>您的数据存储在安全的云服务器上，采用加密传输（HTTPS/TLS）和加密存储</li>
        <li>我们使用业界标准的安全措施保护您的数据免受未经授权的访问、泄露或损坏</li>
        <li>数据备份定期进行，以防止数据丢失</li>
      </ul>

      <h3>4.2 数据保留</h3>
      <ul>
        <li>您的账户信息和交易记录将在您使用服务期间持续保留</li>
        <li>如果您删除账户，我们将在合理期限内删除您的个人数据，除非法律法规另有要求</li>
        <li>匿名化的统计数据可能会保留用于产品分析</li>
      </ul>

      <h2>五、信息共享</h2>
      <p>我们不会出售、出租或以其他方式向第三方出售您的个人信息。仅在以下情况下可能会共享信息：</p>
      <ul>
        <li><strong>服务提供商</strong>：我们聘请的协助提供服务的第三方（如云存储、AI 分析服务），且他们须遵守保密义务</li>
        <li><strong>法律要求</strong>：根据法律法规、法院命令或政府要求必须披露时</li>
        <li><strong>保护权益</strong>：为保护 Hilo Studio、用户或公众的权益、财产或安全所必需时</li>
      </ul>

      <h2>六、您的权利</h2>
      <p>您对您的个人信息享有以下权利：</p>
      <ul>
        <li><strong>访问权</strong>：您可以在应用内查看您的所有交易记录和个人信息</li>
        <li><strong>更正权</strong>：您可以随时修改或更新您的交易记录</li>
        <li><strong>删除权</strong>：您可以删除单条交易记录，或联系我们删除您的整个账户</li>
        <li><strong>导出权</strong>：VIP 用户可以导出交易复盘报告（PDF/图片格式）</li>
        <li><strong>撤回同意</strong>：您可以随时停止使用我们的服务</li>
      </ul>

      <h2>七、儿童隐私</h2>
      <p>TradeMirror 不面向 18 岁以下的未成年人提供服务。如果我们发现收集了未成年人的个人信息，将立即删除相关数据。</p>

      <h2>八、隐私协议的变更</h2>
      <p>我们可能会不时更新本隐私协议。任何重大变更将通过应用内通知或您提供的联系方式告知您。变更后的协议在发布时生效。建议您定期查看本协议以了解最新内容。</p>

      <h2>九、联系我们</h2>
      <p>如果您对本隐私协议有任何疑问、意见或请求，请通过以下方式联系我们：</p>
      <ul>
        <li>电子邮件：<a href="mailto:support@taroveil.com">support@taroveil.com</a></li>
        <li>应用内反馈：设置 → 反馈与建议</li>
      </ul>

      <div className="highlight-box">
        <p style={{ marginBottom: 0 }}>使用 TradeMirror 即表示您同意本隐私协议的条款。如果您不同意本协议的任何部分，请停止使用我们的服务。</p>
      </div>
    </div>
  )
}

export default PrivacyPage
